import { useState } from "react";
import { useTranslation } from "react-i18next";

const ColorPickerInput = ({ color, setColor }) => {
    const [manualInput, setManualInput] = useState(false); // Toggle between manual input and color picker
    const { t } = useTranslation();

    const handleToggle = () => {
        setManualInput((prev) => !prev);
    };

    return (
        <div className="flex flex-col items-start space-y-4 p-4 border rounded-lg shadow-md">
            {/* Color Picker Input */}
            <div className="flex items-center space-x-2">
                <label className="font-semibold">{t("label_select_color")}:</label>
                {manualInput ? (
                    <input
                        type="text"
                        value={color}
                        onChange={(e) => setColor(e.target.value)}
                        className="border border-gray-400 p-2 rounded-md w-28"
                    />
                ) : (
                    <input
                        type="color"
                        value={color}
                        onChange={(e) => setColor(e.target.value)}
                        className="w-10 h-10 border rounded-md cursor-pointer"
                    />
                )}
            </div>

            {/* Custom Switch */}
            <div className="flex items-center space-x-3">
                <span className="font-semibold">{t("label_manual_input")}:</span>
                <div
                    className={`w-12 h-6 flex items-center rounded-full p-1 cursor-pointer ${manualInput ? "bg-green-400" : "bg-gray-300"
                        }`}
                    onClick={handleToggle}
                >
                    <div
                        className={`bg-white w-4 h-4 rounded-full shadow-md transform duration-300 ease-in-out ${manualInput ? "translate-x-6" : ""
                            }`}
                    />
                </div>
            </div>
        </div>
    );
};

export default ColorPickerInput;
